
export default {
  install(app, option) {
    console.log(option)

    // 弹窗移动指令  示例：<div v-move="'.title'"><div class="title">头部(按下可拖动)</div><div>主体</div></div>
    app.directive('move', {
      bind(el, binding, vnode, prevVnode) {
        // console.log('mounted');
        // console.log(el, binding, vnode, prevVnode)

        let dialogBox = el,
          dialogHead = binding.value ? el.querySelector(binding.value) : el
        // console.log(dialogBox, dialogHead)
        if (!dialogHead) {
          console.error('未找到 ' +  (binding.value) + ' 对应的元素', el, binding, vnode, prevVnode)
          return
        }
        
        dialogHead.addEventListener('mousedown', move);
        dialogHead.addEventListener('touchstart', move);

        function move (e) {
          let innerWidth = window.innerWidth,
              innerHeight = window.innerHeight
          let proportion = 1920 / innerWidth;
          //获取需要移动的弹窗
          let eTarget = dialogBox;

          if (e.type === 'touchstart') {
            e.clientX = e.touches[0].clientX;
            e.clientY = e.touches[0].clientY;
          }

          const disX = e.clientX - eTarget.offsetLeft;
          const disY = e.clientY - eTarget.offsetTop;

          // 事件绑在document.body上，是因为想要在lDialog中通过触发document的mouseup事件来关闭所有el-select-dropdown
          document.body.addEventListener('mousemove', onDragging);
          document.body.addEventListener('mouseup', onDragEnd);
          document.body.addEventListener('touchmove', onDragging, { passive: false });//触摸屏移动
          document.body.addEventListener('touchend', onDragEnd);

          function onDragging(e) {
            if (e.cancelable) { // 判断是否可取消事件
              e.preventDefault(); // 阻止默认行为
            }
            if (e.type === 'touchmove') {
              e.clientX = e.touches[0].clientX;
              e.clientY = e.touches[0].clientY;
            }
            let clientX = e.clientX,
                clientY = e.clientY
            
            // 防止出边界
            if (clientX < 20) {
              clientX = 20
            } else if (clientX > innerWidth - 20) {
              clientX = innerWidth - 20
            }
            if (clientY < 20) {
              clientY = 20
            } else if (clientY > innerHeight - 20) {
              clientY = innerHeight - 20
            }

            // 计算
            var l = (clientX - disX) * proportion / 100;
            var t = (clientY - disY) * proportion / 100;

            eTarget.style.left = l + "rem";
            eTarget.style.top = t + "rem";
          }

          function onDragEnd() {
            document.body.removeEventListener('mousemove', onDragging);
            document.body.removeEventListener('touchmove', onDragging);
            document.body.removeEventListener('touchend', onDragEnd);
            document.body.removeEventListener('mouseup', onDragEnd);
          }
        }
        
      }
    })

    // 防抖指令  示例：<div v-antiShake:500.click="(e)=>{foo(e)}"></div>
    app.directive('antiShake', {
      bind: function (el, binding) {
        let timeObj = null

        let timeout = binding.arg ? +binding.arg : 500
        timeout = isNaN(timeout) ? 500 : timeout

        let eventList = Object.keys(binding.modifiers)
        if (eventList.length <= 0) {
          eventList.push('click')
        }
        eventList.forEach((event)=>{
          el.addEventListener(event, foo);
        })
        
        function foo () {
          clearTimeout(timeObj)
          timeObj = setTimeout(() => {
            binding.value(...arguments)
          }, timeout);
        }
      },
    })

    // 节流指令  示例：<div v-throttle:500.click="(e)=>{foo(e)}"></div>
    app.directive('throttle', {
      bind: function (el, binding) {
        let flag = false

        let timeout = binding.arg ? +binding.arg : 500
        timeout = isNaN(timeout) ? 500 : timeout

        let eventList = Object.keys(binding.modifiers)
        if (eventList.length <= 0) {
          eventList.push('click')
        }
        eventList.forEach((event)=>{
          el.addEventListener(event, foo);
        })

        function foo () {
          if (flag) {
            return
          }
          flag = true
          binding.value(...arguments)
          setTimeout(() => {
            flag = false
          }, timeout);
        }
      },
    })

  }
}
